module.exports = __webpack_public_path__ + "img/30.a02aec27.jpg";